import { render, staticRenderFns } from "./PackageQuoteLayout.vue?vue&type=template&id=3272fb43&scoped=true"
import script from "./PackageQuoteLayout.vue?vue&type=script&lang=js"
export * from "./PackageQuoteLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272fb43",
  null
  
)

export default component.exports